<template>
    <div v-if="product.info">
        <div v-if="product.info.description">
            {{ product.info.description }}
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class TransferInfo extends Vue {
        @Prop({required: true}) product
    }

    export default TransferInfo
</script>
